var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarihiYerler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#5B80D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.423 7.041l4.99-2.406a1.35 1.35 0 011.174 0l4.99 2.406c.259.122.423.37.423.637 0 .399-.354.723-.783.723H5.789C5.354 8.4 5 8.077 5 7.678c0-.267.164-.515.423-.637zm.84 3.384v2.314c0 .48.424.868.948.868s.947-.387.947-.867v-2.315c0-.48-.423-.867-.947-.867s-.947.387-.947.867zm3.79 0v2.315c0 .48.423.867.947.867s.947-.387.947-.867v-2.315c0-.48-.423-.867-.947-.867s-.947.387-.947.867zm6 6.075H5.947c-.524 0-.947-.388-.947-.868s.423-.868.947-.868h10.106c.524 0 .947.388.947.868s-.423.868-.947.868zm-2.211-6.075v2.314c0 .48.423.868.947.868s.947-.387.947-.867v-2.315c0-.48-.423-.867-.947-.867s-.947.387-.947.867z",
    fill: "#fff"
  })));
}
export default SvgTarihiYerler;